import request from '@/utils/request'

export function findTypeList(data) {
    return request({
      module: 'center',
      url: '/masterCaseType/findTypeList',
      method: 'post',
      data: data,
      type: 'app'
    })
  }


// WEBPACK FOOTER //
// ./src/api/center/master-case-type.js